import { mutatorAction } from 'satcheljs';
import { mobileDeviceFullStore } from '../store/store';
export var toggleDeviceLoggingEnabled = mutatorAction('toggleDeviceLoggingEnabled', function () {
    var store = mobileDeviceFullStore();
    store.isLoggingEnabled = !store.isLoggingEnabled;
});
//# sourceMappingURL=toggleDeviceLoggingEnabled.js.map